import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn, getHomeRouteForLoggedInUser } from '@/auth/utils'
import master from './routes/master'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...pages,
    ...master,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error_page/Error404.vue'),
      meta: {
        // layout: 'full',
      },
    },
    {
      path: '/error-403',
      name: 'error-403',
      component: () => import('@/views/error_page/Error403.vue'),
      meta: {
        // layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  // Clear any existing session when user visits registration page
  if (to.path === '/daftar-new') {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('userData')
    localStorage.removeItem('permissions')
    localStorage.removeItem('userPermission')
  }

  const isLoggedIn = isUserLoggedIn()

  // Redirect if not authenticated
  if (to.matched.some(record => record.meta.auth)) {
    if (!isLoggedIn) {
      return next({ name: 'login' })
    }
    return next()
  }

  // Redirect if authenticated
  if (to.matched.some(record => record.meta.guest) && isLoggedIn) {
    return next(getHomeRouteForLoggedInUser())
  }

  return next()
})

export default router
